import React, { useState, useEffect } from 'react';
import PlanList from './PlanList';
import PlanForm from './PlanForm';
import { planService } from '../../services/planService';
import './PlanManagement.scss';

const PlanManagement = () => {
    const [view, setView] = useState('list'); // 'list' | 'form'
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [catalog, setCatalog] = useState([]);

    useEffect(() => {
        const loadCatalog = async () => {
            try {
                const response = await planService.getFeatureCatalog();
                if (response.success) setCatalog(response.data.catalog || []);
            } catch (error) {
                console.error('Özellik kataloğu yüklenemedi:', error);
            }
        };
        loadCatalog();
    }, []);

    const handleSelect = (plan) => {
        setSelectedPlan(plan);
        setView('form');
    };

    const handleCreateNew = () => {
        setSelectedPlan(null);
        setView('form');
    };

    const handleBack = () => {
        setView('list');
        setSelectedPlan(null);
    };

    return (
        <div className="plan-management-container">
            {view === 'list' && (
                <PlanList onPlanSelect={handleSelect} onCreateNew={handleCreateNew} />
            )}
            {view === 'form' && (
                <PlanForm plan={selectedPlan} catalog={catalog} onSaved={handleBack} onCancel={handleBack} />
            )}
        </div>
    );
};

export default PlanManagement;
